import { useEffect, useState } from 'react';

import { DEFAULT_LOCALE, getPrefix } from 'i18n/useTranslations';
import {
  getAllowedLocales,
  getSafeLocaleFromUrl,
} from 'lib/navigation/getSafeLocaleFromUrl';

/**
 * This redirects to the active language
 * according to the following algo:
 *
 * 1. If the locale is set in url use that
 * 2. Fallback to first browser locale that is supported
 * 3. Fallback to english
 */
export const useBasenameLocale = () => {
  // eslint-disable-next-line no-restricted-properties
  const localeFromUrl = window.location.pathname.split('/')[1] ?? '';
  const prefix =
    localeFromUrl.length > 5 || localeFromUrl.length < 2
      ? undefined
      : getPrefix(localeFromUrl ?? '');
  const [basename, setBasename] = useState(prefix);
  // eslint-disable-next-line no-restricted-properties
  const safeLocale = getSafeLocaleFromUrl(window.location.pathname);
  const [loading, setLoading] = useState(
    safeLocale !== DEFAULT_LOCALE &&
      (prefix === undefined || prefix !== `/${localeFromUrl}`)
  );
  const setLocale = (locale: string | null) => {
    // eslint-disable-next-line no-restricted-properties
    const { pathname, search, hash } = window.location;
    const newAllowedLocale = getAllowedLocales(locale);
    const newPrefix = newAllowedLocale && getPrefix(newAllowedLocale);
    if (newPrefix) {
      setLoading(true);
      // eslint-disable-next-line no-restricted-properties
      window.history.replaceState(
        null,
        '',
        `${newPrefix}${prefix ? pathname.replace(/\/.*?\//, '/') : pathname}${search}${hash}`
      );
      setBasename(newPrefix);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      setLocale(safeLocale);
    }
  });

  return {
    locale: safeLocale,
    setLocale,
    basename,
    loading,
  };
};
